/**
 * Created by Daniela on 11/10/2016.
 */
import { ValidationResult } from "./interface.validation";

export class Gtin13Validator {
    static gtin13Format(item: any): ValidationResult {
        let gtin: any = item.value;

        if (gtin) {
            gtin = gtin.replace(/\D/g, '');
            
            // Check length of barcode for validity
            if (!CheckBasics(gtin)) {
                return { "incorrectGtin13Format": true };
            }

            // Define fixed variables
            let CheckDigitArray: any = [];
            const gtinMaths = [3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3];
            let modifier = 17 - (gtin.length - 1); // Gets the position to place first digit in array
            const BarcodeArray = gtin.split("");     // Split barcode at each digit into array
            const gtinLength = gtin.length;
            let tmpCheckSum: any = 0;

            let i: any;
            // Run through and put digits into multiplication table
            for (i = 0; i < (gtinLength - 1); i++) {
                CheckDigitArray[modifier + i] = BarcodeArray[i];  // Add barcode digits to Multiplication Table
            }

            // Calculate "Sum" of barcode digits
            for (i = modifier; i < 17; i++) {
                tmpCheckSum += (CheckDigitArray[i] * gtinMaths[i]);
            }

            // Difference from Rounded-Up-To-Nearest-10 - Fianl Check Digit Calculation
            let tmpCheckDigit: any = (Math.ceil(tmpCheckSum / 10) * 10) - parseInt(tmpCheckSum);

            // Check if last digit is same as calculated check digit
            if (gtin.slice(-1) != tmpCheckDigit) {
                return { "incorrectGtin13Format": true };
            }

            return null;
        }

        function CheckBasics(gtin: any) {
            // Check length is ok
            if (gtin.length != 8 && gtin.length != 12 && gtin.length != 13 && gtin.length != 14) {
                return false;
            }

            // Check whether is a number
            const m = gtin.match(/\d+/);
            if (isNaN(m[0])) {
                return false;
            }

            // Is valid, return true
            return true;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/gtin13.validatior.ts
 **/